import classNames from 'classnames';
import Ticket from './components/Ticket';
import SignedDocument from './components/SignedDocument/SignedDocument';
import useRouteHistory from './useRouteHistory';

import styles from './RouteHistory.module.scss';
import React, {Fragment, useEffect, useRef, useState} from 'react';
import {get} from 'lodash';
import {add, parseISO} from 'date-fns';
import {utcToZonedTime, format} from 'date-fns-tz';
import PrintIcon from 'icons/PrintIcon';
import ReactToPrint from 'react-to-print';
import Modal from 'components/Modal';
import {Address, Order, OrderStatus} from 'types';
import {useLocation} from 'react-router-dom';
import AssignedHeader from './components/AssignedHeader';
import NewMap from 'pages/DeliveryPlanner/components/NewMap/NewMap';
import DeleteModal from 'components/DeleteModal';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import Spinner from 'components/Spinner';
import MapPreview from 'components/MapPreview';
import Typography from 'components/Typography';
import NewAddressModal from './components/NewAddressModal';
import InboxModal from './components/InboxModal';
import ButtonWithIcon from 'components/ButtonWithIcon';
import {Trash2Icon} from 'pages/DeliveryPlanner/icons/trash-2';
import PlusIcon from './icons/plus';
import TimerIcon from './icons/timer';
import Button from 'components/Button';
import {OrderDetail} from './components/OrderDetail';
import Attachments from 'components/Attachments';

type LocationProps = {
  showPdf: boolean;
  order_id: string;
};

function RouteHistory() {
  const {
    route,
    onChangeAssignedCheckbox,
    roundedTime,
    currentVehicle,
    vehicles,
    handleDeleteOrder,
    handleDeleteAll,
    handleDragEnd,
    deliveries,
    changingPositions,
    activeOrder,
    setActiveOrder,
    newAddressModal,
    setNewAddressModal,
    defaultCheckedAddressId,
    customerAddressSelectOptions,
    setDefaultCheckedAddressId,
    onChangeAddress,
    createNewAddress,
    addNewDeliveries,
    inboxOrders,
    isAddingNewDeliveries,
    sendDriverNote,
    isSendingNote,
    isRouteFetching,
    isLoading,
    isVehiclesLoading,
  } = useRouteHistory();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [isDeleteAll, setIsDeleteAll] = useState(false);
  const [staffNote, setStaffNote] = useState<string>('');
  const [openedPopup, setOpenedPopup] = useState({
    index: 0,
    open: false,
    refKey: '',
  });
  const location = useLocation<LocationProps | null>();
  const [inboxModal, setInboxModal] = useState(false);

  const documentRef = useRef<HTMLDivElement>(null);
  const foundOrder = useRef(false);
  useEffect(() => {
    if (route && location.state?.showPdf) {
      route.deliveries.forEach((item) => {
        const foundItem = item.orders.find(
          (item) => item.new_leaf_order === String(location.state?.order_id)
        );
        if (foundItem) {
          setActiveOrder(item);
          foundOrder.current = true;
        }
      });
    }
  }, [location, route, setActiveOrder]);
  useEffect(() => {
    if (activeOrder) {
      setStaffNote(get(activeOrder, 'staff_note', '') as string);
    }
  }, [activeOrder]);

  // const handleOrdersClick =
  //   (order: Order) => (e: React.MouseEvent<HTMLDivElement>) => {
  //     e.stopPropagation();
  //     setActiveOrder(order);
  //     setDefaultCheckedAddressId((order?.delivery_address as Address)?.id);
  //   };
  const handleNoteClick =
    (order: Order) => (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      setActiveOrder(order);
      setShowDetailsModal(true);
      setDefaultCheckedAddressId((order?.delivery_address as Address)?.id);
    };

  const handleOrdersClose = () => {
    setShowDetailsModal(false);
    foundOrder.current = false;
  };

  const handleAddNewDeliveries = async (
    deliveryIds: number[],
    callback: () => void
  ) => {
    if (!deliveryIds.length) return;
    try {
      await addNewDeliveries(deliveryIds);
      setInboxModal(false);
    } catch (e) {
      console.error(e);
    } finally {
      // clear checkbox state anytime
      callback();
    }
  };
  const deleteOrder = async () => {
    setDeleting(true);
    if (isDeleteAll) {
      await handleDeleteAll();
    } else {
      await handleDeleteOrder(get(activeOrder, 'id', 0));
    }
    setDeleting(false);
    setDeleteModal(false);
  };

  const markerClick = (key: string) => {
    if (openedPopup.refKey === key) {
      setOpenedPopup((prev) => ({...prev, refKey: key, open: !prev.open}));
    } else {
      setOpenedPopup((prev) => ({...prev, refKey: key}));
    }
  };

  const togglePopup = (index: number, open: boolean, key: string) => {
    setOpenedPopup({
      index,
      open,
      refKey: key,
    });
  };
  const handleOpenMenu = () => {
    setNewAddressModal(true);
  };
  const handleChangeAddress = (selectedAddressId: number) =>
    onChangeAddress(activeOrder?.id!, selectedAddressId, () => {
      setNewAddressModal(false);
    });
  const orderListRef = useRef<HTMLDivElement>(null);
  const isIndividual = route?.team == null;
  const shouldDrawRoute = route?.status !== 'canceled';
  const n = (v: unknown, d = 0) => (v == null ? d : Number(v));

  const completedCount = route?.completed_deliveries_count || 0;
  const totalCount = route?.total_deliveries_count || 0;

  return (
    <Fragment>
      <div
        ref={orderListRef}
        style={{position: 'absolute', zIndex: -100, display: 'none'}}
        className={classNames(styles.panel__content, styles['--assigned'])}
      >
        {deliveries.map((ticket, index) => {
          return (
            <Ticket
              isAssigned={true}
              key={ticket.id}
              isPrint={true}
              showTime={true}
              index={index + 1}
              onChangeCheckbox={onChangeAssignedCheckbox}
              ticket={ticket}
              handleNoteClick={handleNoteClick(ticket)}
            />
          );
        })}
      </div>

      <div className={styles.root}>
        <div className={styles.panel}>
          {isLoading || isVehiclesLoading || isRouteFetching ? (
            <Spinner className={styles.spinner_loading} />
          ) : (
            <Fragment>
              <AssignedHeader
                drivers={get(route, 'team_snapshot.drivers', [])}
                roundedTime={roundedTime}
                currentVehicle={currentVehicle}
                isIndividual={isIndividual}
                driver={route?.driver}
                vehicles={vehicles?.results}
                startLocation={
                  route.start_location
                    ? {
                        name: route.start_location,
                        lat: route.end_latitude,
                        lng: route.start_longitude,
                      }
                    : {
                        name: '1100 2nd Ave, New York, NY 10022',
                        lat: 0,
                        lng: 0,
                      }
                }
                routes={route.deliveries.length}
                start_time={route.start_time}
                endLocation={
                  route.end_location
                    ? {
                        name: route.end_location,
                        lat: route.end_latitude,
                        lng: route.end_longitude,
                      }
                    : {
                        name: '1100 2nd Ave, New York, NY 10022',
                        lat: 0,
                        lng: 0,
                      }
                }
              />
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="routes">
                  {(provider) => {
                    return (
                      <div
                        ref={provider.innerRef}
                        {...provider.droppableProps}
                        className={classNames(
                          styles.panel__content,
                          styles['--assigned']
                        )}
                      >
                        {deliveries.map((ticket, index) => {
                          return (
                            <Draggable
                              isDragDisabled={route.status !== 'awaiting'}
                              key={ticket.id}
                              draggableId={String(ticket.id)}
                              index={index}
                            >
                              {(provider) => {
                                return (
                                  <div
                                    ref={provider.innerRef}
                                    {...provider.draggableProps}
                                    {...provider.dragHandleProps}
                                  >
                                    <Ticket
                                      togglePopup={togglePopup}
                                      openedPopup={openedPopup}
                                      isAssigned={route.status !== 'completed'}
                                      key={ticket.id}
                                      showTime={true}
                                      index={index + 1}
                                      onChangeCheckbox={
                                        onChangeAssignedCheckbox
                                      }
                                      ticket={ticket}
                                      isCanceled={true}
                                      onDelete={() => {
                                        setIsDeleteAll(false);
                                        setDeleteModal(true);
                                        setActiveOrder(ticket);
                                      }}
                                      handleNoteClick={handleNoteClick(ticket)}
                                    />
                                  </div>
                                );
                              }}
                            </Draggable>
                          );
                        })}
                        {provider.placeholder}
                      </div>
                    );
                  }}
                </Droppable>
              </DragDropContext>
              <div className={styles.panel__assigned_bottom}>
                <div className={styles.routeProgress}>
                  <span className={styles.routeProgress__label}>
                    Route Progress
                  </span>
                  <span className={styles.routeProgress__count}>
                    {completedCount} / {totalCount}
                  </span>
                </div>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressBar__fill}
                    style={{width: `${(completedCount / totalCount) * 100}%`}}
                  ></div>
                </div>

                {route.status === 'awaiting' && (
                  <div className={styles.row}>
                    <ButtonWithIcon
                      onClick={() => {
                        setIsDeleteAll(true);
                        setDeleteModal(true);
                      }}
                      className={styles.skipRemaining}
                      color="danger"
                      icon={<Trash2Icon width={16} height={16} />}
                      size="md"
                      loading={deleting}
                    >
                      Skip Remaining
                    </ButtonWithIcon>
                    <ButtonWithIcon
                      onClick={() => setInboxModal(true)}
                      className={styles.add}
                      color="ghost"
                      icon={<PlusIcon width={16} height={16} />}
                      size="md"
                    >
                      Add
                    </ButtonWithIcon>
                  </div>
                )}
                <div className={styles.panel__assigned_summary}>
                  <ReactToPrint
                    trigger={() => (
                      <button className={styles.panel__deliveries_print_action}>
                        <PrintIcon size={16} />
                      </button>
                    )}
                    onBeforeGetContent={() => {
                      orderListRef.current?.setAttribute(
                        'style',
                        'display:block; z-index:-1000;position:absolute'
                      );
                    }}
                    onAfterPrint={() => {
                      orderListRef.current?.setAttribute(
                        'style',
                        'display:none; z-index:-1000;position:absolute'
                      );
                    }}
                    onPrintError={() => {
                      orderListRef.current?.setAttribute(
                        'style',
                        'display:none; z-index:-1000;position:absolute'
                      );
                    }}
                    content={() => orderListRef.current}
                  />
                  <div className={styles.panel__deliveries_end_time}>
                    <TimerIcon width={12} height={12} />
                    <span>Ends at</span>{' '}
                    {route?.start_time && route.total_time
                      ? format(
                          utcToZonedTime(
                            add(parseISO(route.start_time), {
                              minutes: route.total_time,
                            }),
                            'America/New_York'
                          ),
                          'h:mm aaa',
                          {
                            timeZone: 'America/New_York',
                          }
                        )
                      : '-:-- --'}
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
        <div className={styles.mapContainer}>
          <NewMap
            openedPopup={openedPopup}
            polylines={shouldDrawRoute ? route.polylines : []}
            shouldDrawRoute={shouldDrawRoute}
            markerClick={markerClick}
            end_location={{
              name: route.end_location,
              lat: route.end_latitude,
              lng: route.end_longitude,
            }}
            start_location={{
              name: route.start_location,
              lat: route.start_latitude,
              lng: route.start_longitude,
            }}
            driver_id={
              route.status !== 'completed' && route.status !== 'canceled'
                ? route.driver?.id
                : undefined
            }
            orders={deliveries}
            display={true}
          />
        </div>
      </div>
      <InboxModal
        inboxOrders={inboxOrders}
        isShowModal={inboxModal}
        onClose={() => setInboxModal(false)}
        // handleOrdersClick={handleOrdersClick}
        onAddNewDeliveries={handleAddNewDeliveries}
        isAdding={isAddingNewDeliveries}
      />
      <Modal
        isOpen={showDetailsModal}
        onClose={handleOrdersClose}
        onRequestClose={handleOrdersClose}
        onAfterOpen={() => {
          if (foundOrder.current) {
            documentRef.current?.scrollIntoView();
          }
        }}
        className={styles.list_wrapper}
      >
        <div className={styles.list_innerContainer}>
          <OrderDetail
            handleAddressClick={handleOpenMenu}
            order={activeOrder}
          />
          {activeOrder?.orders &&
            activeOrder?.orders?.length > 0 &&
            activeOrder?.orders[0]?.google_drive_files &&
            activeOrder?.orders[0]?.google_drive_files?.length > 0 && (
              <Attachments
                attachments={activeOrder?.orders[0]?.google_drive_files || []}
              />
            )}
          {get(activeOrder, 'note') && (
            <>
              <Typography variant="p">Worker's note for Delivery:</Typography>
              <div className={styles.orderNote}>
                <Typography variant="label">
                  {get(activeOrder, 'note')}
                </Typography>
              </div>
            </>
          )}

          <Typography variant="p" style={{marginTop: 16}}>
            Note for Worker:{' '}
          </Typography>
          <textarea
            disabled={activeOrder?.status !== 'on_way'}
            name="staff_note"
            id="staff_note"
            placeholder="Enter your note here"
            value={staffNote || ''}
            onChange={(e) => setStaffNote(e.target.value as string)}
            className={styles.staffNote}
          />
          <div className={styles.buttonContainer}>
            <Button
              color="primary"
              size="sm"
              onClick={() => {
                sendDriverNote(Number(activeOrder?.id), staffNote);
              }}
              loading={isSendingNote}
            >
              Save Note
            </Button>
          </div>

          <SignedDocument
            ref={documentRef}
            driver={route.driver}
            order={activeOrder}
          />
          {get(activeOrder, 'status') === ('cancelled' as OrderStatus) &&
            !!get(activeOrder, 'delivery_image', null) && (
              <>
                <Typography variant="p">Skip Image:</Typography>
                <div className={styles.delivery_image}>
                  <img
                    alt="delivery_image"
                    src={
                      get(activeOrder, 'delivery_image.medium', '') as string
                    }
                  />
                </div>
              </>
            )}

          {!!get(activeOrder, 'delivery_latitude', null) && (
            <>
              <Typography variant="p">Completed location:</Typography>
              <div className={styles.row}>
                <div className={styles.completed_location}>
                  <MapPreview
                    zoom={15}
                    style={{height: 300, width: '100%'}}
                    center={[
                      n(get(activeOrder, 'delivery_latitude')),
                      n(get(activeOrder, 'delivery_longitude')),
                    ]}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
      <NewAddressModal
        defaultCheckedAddressId={defaultCheckedAddressId}
        onClose={() => setNewAddressModal(false)}
        isShowModal={newAddressModal}
        onChangeAddress={handleChangeAddress}
        addressIsUpdating={false}
        options={customerAddressSelectOptions as any}
        onCreateNewAddress={createNewAddress}
      />

      <DeleteModal
        openModal={deleteModal}
        setOpenModal={setDeleteModal}
        onDelete={deleteOrder}
        title={
          isDeleteAll
            ? 'Confirm skipping all remaining orders ?'
            : 'Confirm skipping this order ?'
        }
        confirmText={'Confirm skip'}
        component={
          isDeleteAll ? (
            deliveries
              .filter((item) => item.status !== 'completed')
              .map((item) => (
                <div
                  className={classNames(
                    styles.list__item_header,
                    styles.list__item
                  )}
                >
                  <p>Group #</p>
                  <p>{get(item, 'sequential_order_number', 0)}</p>
                </div>
              ))
          ) : (
            <>
              <div
                className={classNames(
                  styles.list__item_header,
                  styles.list__item
                )}
              >
                <p>Customer</p>
                <p>{`${get(activeOrder, 'customer.user.first_name', '')} ${get(
                  activeOrder,
                  'customer.user.last_name',
                  ''
                )}`}</p>
              </div>
              <div
                className={classNames(
                  styles.list__item_header,
                  styles.list__item
                )}
              >
                <p>Dispatch Address</p>
                {typeof get(activeOrder, 'delivery_address') === 'string' ? (
                  <p>{get(activeOrder, 'delivery_address')}</p>
                ) : (
                  <p>
                    {get(activeOrder, 'delivery_address.address_line_1') || ''}{' '}
                    {get(activeOrder, 'delivery_address.address_line_2') || ''}
                    {get(activeOrder, 'delivery_address.city') || ''},{' '}
                    {get(activeOrder, 'delivery_address.state')}{' '}
                    {get(activeOrder, 'delivery_address.zipcode')}
                  </p>
                )}
              </div>
            </>
          )
        }
      />
      <Modal showCloseButton={false} isOpen={changingPositions}>
        <div style={{alignItems: 'center', textAlign: 'center'}}>
          <Spinner className={styles.fetchLoader} />
          <h3>Recalculating arrival times. Please wait...</h3>
        </div>
      </Modal>
    </Fragment>
  );
}

export default RouteHistory;
